import React from 'react';
import { getQueriesFromString, getPotentialResources } from './queries';

function buildSuggestionText({ suggestion, queries, suggestNewQuery, completeQueryAt }) {
  let suggestionText = [];
  queries.forEach((query, index) => {
    if (!suggestNewQuery && index === completeQueryAt) {
      const substringIndex = suggestion.display.toLowerCase().indexOf(query);
      if (substringIndex === 0) {
        suggestionText = [
          ...suggestionText,
          <span key={`${suggestion.display}-op-quote`}>{suggestion.display.includes(' ') ? '"' : null}</span>,
          <span key={`${query}-n`}>{query}</span>,
          <strong key={`${suggestion.display.toLowerCase()}-b`}>
            {suggestion.display.slice(query.length).toLowerCase()}
          </strong>,
          <span key={`${suggestion.display}-cl-quote`}>{suggestion.display.includes(' ') ? '"' : null}</span>,
          ' ',
        ];
      } else if (substringIndex + query.length === suggestion.display.length) {
        suggestionText = [
          ...suggestionText,
          <strong key={`${suggestion.display.toLowerCase()}-b`}>
            {suggestion.display.slice(0, -query.length).toLowerCase()}
          </strong>,
          <span key={`${query}-n`}>{query}</span>,
          ' ',
        ];
      } else {
        const preQuery = suggestion.display.slice(0, substringIndex).toLowerCase();
        const postQuery = suggestion.display.slice(substringIndex + query.length).toLowerCase();
        suggestionText = [
          ...suggestionText,
          <span key={`${suggestion.display}-op-quote`}>{suggestion.display.includes(' ') ? '"' : null}</span>,
          <strong key={`${preQuery}-b`}>
            {preQuery}
          </strong>,
          <span key={`${query}-n`}>{query}</span>,
          <strong key={`${postQuery}-b`}>
            {postQuery}
          </strong>,
          <span key={`${suggestion.display}-cl-quote`}>{suggestion.display.includes(' ') ? '"' : null}</span>,
          ' ',
        ];
      }
    } else {
      suggestionText = [...suggestionText, <span key={`${query}-n`}>{query} </span>];
    }
  });
  if (suggestNewQuery) {
    suggestionText = [
      ...suggestionText,
      <span key={`${suggestion.display}-op-quote`}>{suggestion.display.includes(' ') ? '"' : null}</span>,
      <strong key={`${suggestion.display.toLowerCase()}-b`}>{suggestion.display.toLowerCase()}</strong>,
      <span key={`${suggestion.display}-cl-quote`}>{suggestion.display.includes(' ') ? '"' : null}</span>,
      ' ',
    ];
  }
  return suggestionText;
}

function buildSuggestionPlainText({ suggestion, queries, suggestNewQuery, completeQueryAt }) {
  let plainText = '';
  queries.forEach((query, index) => {
    if (!suggestNewQuery && index === completeQueryAt) {
      if (suggestion.display.toLowerCase().includes(' ')) plainText += `"${suggestion.display.toLowerCase()}" `;
      else plainText += `${suggestion.display.toLowerCase()} `;
    } else if (query.includes(' ')) plainText += `"${query}" `;
    else plainText += `${query} `;
  });
  if (suggestNewQuery) {
    if (suggestion.display.toLowerCase().includes(' ')) plainText += `"${suggestion.display.toLowerCase()}" `;
    else plainText += `${suggestion.display.toLowerCase()} `;
  }
  return plainText;
}

function popularitySort(a, b) {
  if (a.p[0][0] < b.p[0][0]) return 1;
  if (a.p[0][0] > b.p[0][0]) return -1;
  return 0;
}

export default function suggestionsReducer(state, action) {
  console.log('TESTING STATE: ', state);
  if (action.type === 'UPDATE_RESOURCE_SEARCH_TEXT') {
    const { tags, resourceSearchText, view } = state;
    const newText = action.searchText;

    const previousQueries = getQueriesFromString(resourceSearchText);
    const queries = getQueriesFromString(newText);

    // Check if suggestion should complete query, or suggest new query
    const suggestNewQuery = queries.every(query => previousQueries.includes(query));
    let completeQueryAt = 0;

    if (!suggestNewQuery) {
      queries.some((newQuery, i) => {
        if (newQuery === previousQueries[i]) {
          return false;
        }
        completeQueryAt = i;
        return true;
      });
    }

    // Build pool of resources to check that potential suggestions have at least 1 result
    const unchangedQueries = [...queries];
    if (!suggestNewQuery) unchangedQueries.splice(completeQueryAt, 1);
    const modifiedQuery = suggestNewQuery ? undefined : queries[completeQueryAt];
    const potentialResources = getPotentialResources({ state, queries });

    // Check potential tag suggestions against remaining resources
    const potentialSuggestions = suggestNewQuery ? tags :
      state.queries.getQuery({
        state,
        query: modifiedQuery,
      }).tags;
    potentialSuggestions.sort(popularitySort);

    let newSuggestions = [];
    potentialSuggestions.some((nextSuggestion) => {
      const suggestion = {
        ...nextSuggestion,
        results:
          state.queries.getQuery({
            state,
            query: nextSuggestion.display.toLowerCase(),
          }).resources.filter(res => potentialResources.includes(res)),
      };
      if (suggestion.results.length === 0) return false;
      if (queries.includes(suggestion.display.toLowerCase())) return false;
      if (unchangedQueries.some(q => suggestion.display.toLowerCase().split(' ').includes(q))) return false;
      if (view === 'home' && queries.length === 0) {
        if (suggestion.display === 'Academic'
        || suggestion.display === 'Housing'
        || suggestion.display === 'Community'
        || suggestion.display === 'Employment') return false;
      }
      if (modifiedQuery
        && modifiedQuery.length < 4
        && suggestion.display.toLowerCase().indexOf(modifiedQuery) !== 0) return false;
      newSuggestions.push(suggestion);
      if (newSuggestions.length >= 10) return true;
      return false;
    });

    // Build suggestion elements
    newSuggestions = newSuggestions.map(suggestion => (
      {
        ...suggestion,
        suggestionText:
          buildSuggestionText({ suggestion, queries, suggestNewQuery, completeQueryAt }),
        value: buildSuggestionPlainText({ suggestion, queries, suggestNewQuery, completeQueryAt }),
      }
    ));
    return {
      ...state,
      suggestions: newSuggestions,
    };
  }
  return state;
}



// WEBPACK FOOTER //
// ./src/reducers/suggestions.jsx